import { Typography } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom';

/**
* @author
* @function HouseRegistration
**/

const HouseRegistration = (props) => {
  return(
    <div>
<Typography variant="h4" gutterBottom className="m-head-textf" >
            Sorry Service Not Available !! This Page Is Under Construction 
          </Typography>

          <h3><Link to="/">Back To Home</Link></h3>
    </div>
   )

 }

export default HouseRegistration